import { CheckboxProps } from '@app/types'
import { Checkbox as AntCheckbox } from 'antd'

export const Checkbox: React.FC<CheckboxProps> = (props) => <AntCheckbox {...props} />
